import React, { useEffect, useState } from "react";
import Hero from "./components/Hero";
import FiBiChoices from "./components/FiBiChoices";
// import Features from "./components/Features";
import FeaturedVideo from "./components/FeaturedVideo";
import SEOMeta from "../../components/SEOMeta";
import { WebPaths } from "../../../../routes/data";
import { SVLogoSquare } from "../../../../images";
import EnhancedBanner from "./components/EnhancedBanner";
import useOpener from "../../../../hooks/useOpener";
import ReserveFreeTrialModal from "../../landing page/components/ReserveFreeTrialModal";
import FibiTestimonials from "./components/FibiTestimonials";
import storage from "../../../../utils/storage";
import { hasFibiFreeTrialText } from "../../landing page/components/data";
import InterviewSampleModal from "./components/InterviewSampleModal";
import PreInterviewModal from "./components/PreInterviewModal";

const FiBi = () => {
  const { onClose, onOpen, open } = useOpener();
  const hasFibiFreeTrial = storage.get(hasFibiFreeTrialText);
  const [openSampleModal, setOpenSampleModal] = useState(false);
  const [openPreInterviewModal, setOpenPreInterviewModal] = useState(false);

  useEffect(() => {
    console.log("hmm1");
    setOpenPreInterviewModal(true);

    return () => {
      console.log("hmm2");
      setOpenPreInterviewModal(false);
    };
  }, []);

  useEffect(() => {
    if (openSampleModal || openPreInterviewModal) return;
    if (hasFibiFreeTrial) return;
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0) {
        onOpen();
      }
    };

    document.addEventListener("mouseout", handleMouseLeave);

    return () => {
      document.removeEventListener("mouseout", handleMouseLeave);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFibiFreeTrial, openSampleModal, openPreInterviewModal]);

  useEffect(() => {
    if (openSampleModal || openPreInterviewModal) return;
    if (hasFibiFreeTrial) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const scrolled = scrollTop / (docHeight - windowHeight);

      if (scrolled > 0.1) {
        // 10% down the page
        onOpen();
        window.removeEventListener("scroll", handleScroll); // only trigger once
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // adding onOpen messes things up, leave empty
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFibiFreeTrial, openSampleModal, openPreInterviewModal]);

  const onClosePreInterview = () => {
    setOpenPreInterviewModal(false);
  };

  return (
    <>
      <div>
        <SEOMeta
          title="FiBi AI Assistant | Your Personalized Interview Trainer"
          description="Meet FiBi, your AI-powered assistant for visa risk checks, form reviews, and interview simulations. Get the expert guidance you need to navigate the visa application process."
          canonicalUrl={`https://www.seamlessvisa.com${WebPaths.FiBiAi}`}
          url={`https://www.seamlessvisa.com${WebPaths.FiBiAi}`}
          siteName="SeamlessVisa"
          publisher="https://www.facebook.com/share/1BhLA5r2Ac/"
          imageUrl={SVLogoSquare}
          imageWidth="1920"
          imageHeight="1080"
          imageType="image/png"
          twitterCard="summary_large_image"
          twitterTitle="FiBi AI Assistant | SeamlessVisa"
          twitterDescription="Meet FiBi, your AI-powered assistant for visa risk checks, form reviews, and interview simulations. Get the expert guidance you need to navigate the visa application process."
          twitterSite="@SeamlessVisa_"
        />
        {/* banner */}
        <EnhancedBanner />
        <Hero />

        <FiBiChoices />
        <FibiTestimonials />
        {/* <Features /> */}
        <FeaturedVideo />
      </div>

      {open && <ReserveFreeTrialModal onClose={onClose} />}
      {openPreInterviewModal && (
        <PreInterviewModal
          onClose={onClosePreInterview}
          onOpenMainModal={() => {
            onClosePreInterview();
            setOpenSampleModal(true);
          }}
        />
      )}
      {openSampleModal && (
        <InterviewSampleModal onClose={() => setOpenSampleModal(false)} />
      )}
    </>
  );
};

export default FiBi;
